import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import TopHeading from "../Heading/TopHeading";
import { Avatar, Loader } from "../UI";
import { TbCameraPlus } from "react-icons/tb";
import ChangePasswordModal from "./ChangePasswordModal";
import axios from "../../axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function ProfileContent() {
  const authToken = localStorage.getItem("access_token");
  const isAdmin = localStorage.getItem("isAdmin");
  const user = JSON.parse(localStorage.getItem("user"));
  const [data, setData] = useState({});
  const [profilePic, setProfilePic] = useState(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = () => setShow(!show);

  const changePassword = (values, setSubmitting) => {
    axios
      .post("/change-password", values, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 2000,
              padding: "2em",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.timer) {
                handleClose();
              }
            });
          } else {
            toast.warn("No response from server");
          }
        }
        setSubmitting(false);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.log(error);
        }
      });
  };

  const fetchProfile = () => {
    if (isAdmin == 0) {
      axios
        .get("/profile", {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setData(response.data[0]);
            setProfilePic(response.data[0].profilePhoto);
            localStorage.setItem("user", JSON.stringify(response.data));
          } else {
            toast.warn("No response from server");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    } else {
      setIsLoading(false);
      setData(user[0]);
    }
  };

  const profilePhotoUpdate = (e) => {
    setIsLoading(true);
    let photoObject = { profilePhoto: e.target.files[0] };
    axios
      .post("/profile-photo", photoObject, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            fetchProfile();
            toast.success(response.data.message);
          }
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.log(error);
        }
      });
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <section className="profile-content mb-3">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title="Profile" />
            <div className="profile light-bg corner-radius p-4">
              <div className="text-end">
                <Button variant="secondary" onClick={handleClose}>
                  Change Password
                </Button>
                <ChangePasswordModal
                  show={show}
                  handleClose={handleClose}
                  changePassword={changePassword}
                />
              </div>
              <div className="d-flex justify-content-center mt-md-0 mt-5 mb-3">
                <div>
                  <div className="profile-pic-wrap">
                    <Avatar
                      image={profilePic}
                      imageClass="profile-pic-placeholder"
                    />
                    <TbCameraPlus size={28} />
                  </div>
                  {isAdmin == 0 && (
                    <div className="profile-pic-input">
                      <Form>
                        <Form.Control
                          type="file"
                          id="profilePic"
                          name="profilePic"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={profilePhotoUpdate}
                        />
                        <Form.Label htmlFor="profilePic" className="mt-2">
                          <span>Change Photo</span>
                        </Form.Label>
                      </Form>
                    </div>
                  )}
                </div>
              </div>
              {isLoading ? (
                <Loader />
              ) : (
                <div className="row g-0">
                  <div className="col-md-6 pe-2">
                    <div className="mb-3">
                      <Form.Label className="data-label">First Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={data.firstName}
                        disabled
                      />
                    </div>
                    <div className="mb-3">
                      <Form.Label className="data-label">
                        Username/Email
                      </Form.Label>
                      <Form.Control type="text" value={data.email} disabled />
                    </div>
                    {isAdmin == 0 && (
                      <div className="mb-3">
                        <Form.Label className="data-label">Address</Form.Label>
                        <Form.Control
                          type="text"
                          value={
                            data.guardianAddress1 +
                            ", " +
                            data.guardianAddress2 +
                            ", " +
                            data.guardianCity
                          }
                          disabled
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 ps-2">
                    <div className="mb-3">
                      <Form.Label className="data-label">Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={data.lastName}
                        disabled
                      />
                    </div>
                    {isAdmin == 0 && (
                      <>
                        <div className="mb-3">
                          <Form.Label className="data-label">
                            Phone Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={data.guardianPhone1}
                            disabled
                          />
                        </div>
                        <div className="mb-3">
                          <Form.Label className="data-label">
                            Postcode
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={data.guardianPostcode}
                            disabled
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
